// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"bd1dd948","498":"f57af8de","703":"29775710"}[chunkId] + ".chunk.js";
};